import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import React, { FC } from 'react';
import { REFUND_TYPE } from './OrderItem';

interface Props {
	setReason: (value: string) => void;
	closeModal: () => void;
	onConfirm: (refundType: REFUND_TYPE) => Promise<void>;
	refundType: REFUND_TYPE;
	isRefundItemsLoading: boolean;
}

export const RefundModalContent: FC<Props> = (props) => {
	const { setReason, closeModal, onConfirm, refundType, isRefundItemsLoading } = props;
	return (
		<div className="mx-7">
			<div className="fs-3 mb-3">Attention! This action cannot be undone</div>
			<div className="fs-5 mb-5">Please, write the reason for the refund (optional):</div>
			<textarea
				className="form-control form-control-sm form-control-solid mt-1 h-150px resize-none"
				placeholder="Write reason here"
				maxLength={250}
				onChange={(e): void => setReason(e.target.value)}
			/>
			<div className="text-center mt-5">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName="Confirm"
					type="submit"
					additionalClass="btn-sm ms-10 w-100px"
					onButtonClick={(): Promise<void> => onConfirm(refundType)}
					loading={isRefundItemsLoading}
				/>
			</div>
		</div>
	);
};
